import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Nav, NavItem, NavLink, Spinner } from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import { usePartnerValuePerSource } from "../query/hooks";

const SourceDividedValueChart = ({ selectedCurrency, partnerId, selectedTenantId, tracked = false }) => {
  const [activeTab, setActiveTab] = useState(0);

  const {
    data: sources,
    isLoading,
    isRefetching,
    isSuccess,
  } = usePartnerValuePerSource(partnerId, selectedTenantId, tracked);

  const chartOptions = (source) => {
    // Process and limit to top 15 results
    const processedSeries = source.data.series.map((serie) => {
      // Create array with currency conversion applied
      const processedData = serie.data.map(point => {
        const value = Array.isArray(point) ? point[1] : point;
        const convertedValue = (value && !isNaN(value)) ? Math.round(value * (selectedCurrency?.value || 1)) : 0;
        return {
          name: Array.isArray(point) ? point[0] : '',
          y: convertedValue
        };
      });

      // Sort by value (descending) and take top 15
      const sortedData = processedData
        .sort((a, b) => b.y - a.y)
        .slice(0, 15);

      return {
        ...serie,
        data: sortedData,
        dataSorting: {
          enabled: true,
        },
        borderColor: null,
      };
    });

    return {
      credits: {
        enabled: false
      },
      chart: {
        type: "bar",
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: source.data.yTitle,
        },
        labels: {
          style: {
            color: 'var(--text-primary)'
          }
        },
      },
      xAxis: {
        type: 'category',
        min: 0,
        labels: {
          animate: true,
          style: {
            color: 'var(--text-primary)'
          }
        }
      },
      series: processedSeries,
      plotOptions: {
        column: {
          stacking: "normal",
        },
      },
    };
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const renderTab = (graph, index) => {
    return (
      <NavItem key={index}>
        <NavLink
          href="#"
          className={classnames({ active: activeTab === index })}
          onClick={() => toggleTab(index)}
        >
          {graph.source}
        </NavLink>
      </NavItem>
    );
  };

  const renderSource = (graph, index) => {
    const chart = JSON.parse(JSON.stringify(chartOptions(graph)));
    return <HighchartsReact highcharts={Highcharts} options={chart} />;
  };

  return (
    <>
      {(isLoading || isRefetching) && <Spinner color="primary" />}
      {isSuccess && (
        <>
          <Nav pills className="navtab-bg my-4 center-pills">
            {sources.map((source, index) => renderTab(source, index))}
          </Nav>
          {sources[activeTab] && renderSource(sources[activeTab])}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
});

export default connect(mapStateToProps)(SourceDividedValueChart);
